module.exports = __webpack_public_path__ + "img/selcare-logo.a0847fb9.svg";